// Generated code for Big.Domain.Enums.DuoDiplomaNiveau.
// Edit _Enum.tst to change the generated output.

export enum DuoDiplomaNiveau {
    onbekend = 0,
    m3 = 1,
    m4 = 2,
    b = 3,
    m = 4,
    p = 5
}
(DuoDiplomaNiveau as any).name = 'DuoDiplomaNiveau';
